module.exports = {
  "board_thumbnail":          {  width: 228, height: 154 },
  "item_thumbnail":           {  width: 178, height: 118 },
  "campaign_thumbnail":       {  width: 297, height: 197 },
  "contained":                { crop: "fit" },
  "face":                     { crop: "thumb", gravity: "face", radius: "max"},
  "default":                  { crop: "fit" }
};
